var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Closingstatement',{ref:"finalClo",staticStyle:{"background":"#fff"},attrs:{"myArrayProp2":_vm.myArrayProp,"iid":_vm.iid,"isDownPdf":_vm.isDownPdf}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }